import { z } from 'zod';
import { quantitySchema } from '../../validation';
import { vehicleQuantityAndTypeSchema } from '../../common';

/**
 * @deprecated Part of the legacy `Carrier` collection. The unified
 * `Org` collection captures vehicle counts via onboarding metadata
 * instead. See `CarrierSchema` for the full deprecation note.
 */
export const carrierVehicleCount = z.object({
  /** this will be given by the user  */
  total: quantitySchema.min(1),
  /** this will be given by the user  */
  types: z.array(vehicleQuantityAndTypeSchema).min(1),
});
